import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RubyOutlinedSvg from "@ant-design/icons-svg/es/asn/RubyOutlined";
import AntdIcon from '../components/AntdIcon';
var RubyOutlined = function RubyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: RubyOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(RubyOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'RubyOutlined';
}
export default RefIcon;